import React from 'react';
import $ from "jquery";
import {connect} from "react-redux";
import {FormattedMessage} from "react-intl";

import {setMaterialsAgentTutorialFinished, showMaterialsAgentTutorial} from "../../actions/tutorialFunctions";
import Tutorial from "./tutorial";


class MaterialsAgentTutorial extends Tutorial {

  constructor(props) {
    super(props);
    this.state = {
      ringStyles: {
        left: 0,
        top: 0,
      }
    };
    this.resizeId = 0;
  }

  componentDidMount = () => {
    if (this.props.materialsAgentTutorialFinished) {
      return null
    }
    const scriptAdded = document.getElementById("pingpilot");
    if (!scriptAdded) {
      return null
    }
    const pingButton = document.querySelector(".pingpilot-button");
    if (!pingButton) {
      return null
    }
    window.materialsAgentTutorialTimeoutId = setTimeout(() => {
      this.props.showMaterialsAgentTutorial(true);
      this.setButtonsPositions();
      $(".tutorial-overlay--materials").fadeIn(300);
      $(".tutorial-step__ring, .tutorial-step").fadeIn(300, () => {
        this.setButtonsPositions();
      });
      window.addEventListener("resize", this.handleResize);
    }, 30000);
  };

  handleResize = () => {
    clearTimeout(this.resizeId);
    this.resizeId = setTimeout(this.setButtonsPositions, 500);
  };

  setButtonsPositions = () => {
    this.changeHighlightRingPosition(".omnibrowse-code-button");
  };

  componentWillUnmount() {
    window.clearTimeout(window.materialsAgentTutorialTimeoutId);
    window.removeEventListener("resize", this.handleResize);
  }

  handleNextStepClick = () => {
    this.exitTutorial(true);
  };

  exitTutorial = (forever) => {
    $(".tutorial-overlay--materials").fadeOut(300, () => {
      this.props.showMaterialsAgentTutorial(false);
      if (forever) {
        this.props.setMaterialsAgentTutorialFinished(true);
        try {
          window.localStorage.setItem("materials_tutorial_finished", true);
        } catch (ex) { console.log("localStorage exception", ex); }
      }
    });
  };

  pingButtonClick = () => {
    this.exitTutorial(true);
    const pingButton = document.querySelector(".pingpilot-button");
    if (!pingButton) {
      return null
    }
    pingButton.click();
  }

  render() {

    const {materialsAgentTutorialIsOpened, materialsAgentTutorialFinished, isMobile} = this.props;

    if (!materialsAgentTutorialIsOpened || materialsAgentTutorialFinished) {
      return null
    }

    return (
      <div className={"tutorial-overlay tutorial-overlay--materials"}>
        <div className={"tutorial tutorial--agent"}>
          <div className="tutorial-main tutorial-main--with-image tutorial-main__agent" style={{
            left: this.state.ringStyles.left + (isMobile ? 120 : 250),
          }}>
            <div className="tutorial-main__agent-image"/>
            <p className="tutorial-main__text" id="tutorial-text">
              <FormattedMessage id="tutorials.materialsPage.agent.title"/><br/>
              <FormattedMessage id="tutorials.materialsPage.agent.title2"/>
            </p>
            <div className="tutorial-main__agent-arrow"/>
            <div className="tutorial-main__buttons">
              <button className="ui-button3 ui-button3--green ui-button3--wide pulsating--green"
                      onClick={() => this.exitTutorial(true)} id="tutorial-close">
                <FormattedMessage id="tutorials.materialsPage.agent.continue"/>
              </button>
            </div>
          </div>
          <span className="tutorial-step__ring tutorial-step__ring--scale" style={{
            "transform": "translate("+this.state.ringStyles.left+"px, "+this.state.ringStyles.top+"px)"
          }}/>
          <div className="tutorial-step tutorial-step--mat-agent" style={{
            left: this.state.ringStyles.left,
            top: this.state.ringStyles.top,
          }}>
            <button className="selection-main__image-button omnibrowse-code-button" onClick={this.pingButtonClick} />
          </div>
        </div>
      </div>
    )
  }

}

const mapStateToProps = (store) => {
  const {materialsAgentTutorialIsOpened, materialsAgentTutorialFinished} = store.tutorialState;
  const {isMobile} = store.serverState;

  return {
    materialsAgentTutorialIsOpened,
    materialsAgentTutorialFinished,
    isMobile,
  };
};

const mapDispatchToProps = {
  showMaterialsAgentTutorial,
  setMaterialsAgentTutorialFinished,
}

export default connect(mapStateToProps, mapDispatchToProps)(MaterialsAgentTutorial);
